import { Symbols } from '@ioc/symbols'
import { inject, injectable } from 'inversify'

import { type ErrorMonitoring } from '@writefull/core'

import { SessionStore } from '@infrastructure/stores/session/session-store'

@injectable()
export class SessionStateObserver {
  constructor(
    @inject(SessionStore) private readonly sessionStore: SessionStore,
    @inject(Symbols.ERROR_MONITORING) private readonly errorMonitoring: ErrorMonitoring,
  ) {}

  public init(): void {
    this.sessionStore.subscribe(
      (s) => s.user,
      (user) => {
        if (user) {
          this.errorMonitoring.setUserId(user.uid)
        }
      },
    )
  }
}
